<template>
  <b-modal
    id="delete-entries"
    ref="delete-entries"
    size="edit-entries"
    centered
    hide-footer
    hide-header
    @hide="close"
  >
    <div class="modal-head">
      <h2 class="modal-title">
        {{ label.get("delete_entries") }}
      </h2>
    </div>
    <div class="content-wrapper">
      <div v-for="(item, idx) in mappedEntries" :key="idx" class="field-row">
        <div class="field-details">
          <div class="entry">
            <i class="atto atto-status-circle" />
            <p class="entry-label">Entry {{ idx + 1 }}</p>
          </div>
          <div class="time-interval">
            <span class="start-time">
              {{ item.start_time }}
            </span>
            <i class="atto atto-rdir-arrow-b" />
            <span class="end-time">
              {{ item.end_time }}
            </span>
          </div>
          <button
            v-if="!item.deleting"
            class="delete-entry"
            @click="deleteEntry(idx)"
          >
            <i class="atto atto-delete" />
          </button>
          <transition name="fade">
            <div v-if="item.confirm_delete" class="confirm-delete">
              <span class="confirm-msg">{{ label.get("are_you_sure") }}</span>
              <button class="confirm-delete-btn" @click="confirmDelete(item)">
                {{ label.get("delete") }}
              </button>
              <button class="cancel-delete" @click="cancelConfirmDelete(idx)">
                <i class="atto atto-close-btn" />
              </button>
            </div>
          </transition>
        </div>
      </div>
    </div>

    <div class="modal-footer overlap">
      <button type="reset" class="atto-btn cancel" @click="close">
        Cancel
      </button>
    </div>
  </b-modal>
</template>

<script>
import TimesheetService from "../TimesheetService";

export default {
  name: "DeleteEntriesComponent",
  props: {
    entries: {
      type: Array,
      default: () => {
        return [];
      },
    },
    member: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      mappedEntries: this.entries.map((item) => {
        item.deleting = false;
        item.confirm_delete = false;
        return item;
      }),
    };
  },
  mounted() {
    this.$refs["delete-entries"].show();
  },
  methods: {
    deleteEntry(idx) {
      let entry = this.mappedEntries[idx];
      entry.confirm_delete = true;
      Vue.set(this.mappedEntries, idx, entry);
    },
    confirmDelete(item) {
      item.deleting = true;
      TimesheetService.deleteEntry(item.id)
        .then((result) => {
          const entryIndex = this.mappedEntries.indexOf(item);
          this.mappedEntries.splice(entryIndex, 1);
          if (this.mappedEntries.length === 0) {
            this.close();
          }
          this.$root.$emit("reloadData");
        })
        .catch((error) => {
          item.deleting = false;
        });
    },
    cancelConfirmDelete(idx) {
      let entry = this.mappedEntries[idx];
      entry.deleting = false;
      entry.confirm_delete = false;
      Vue.set(this.mappedEntries, idx, entry);
    },
    close() {
      // this.$refs['delete-entries'].hide();
      this.$root.$emit("hideDeleteEntries");
    },
  },
};
</script>

<style lang="scss">
.modal-edit-entries {
  max-width: 480px;
  max-height: 448px;
  .modal-body {
    padding: 0;

    .content-wrapper {
      padding: 46px 48px;
      height: auto;
      .field-row {
        position: relative;
        .confirm-delete {
          position: absolute;
          right: 0;
          top: 0;
          background-color: #fff;
          width: 232px;
          height: 40px;
          display: flex;
          align-items: center;
          flex-direction: row;
          justify-content: flex-end;
          padding-left: 34px;

          .confirm-msg {
            font-size: 0.875rem;
            line-height: 1.75rem;
            font-family: "Roboto", sans-serif;
            font-weight: 400;
            color: #262626;
          }

          .confirm-delete-btn {
            font-size: 0.875rem;
            line-height: 1.75rem;
            font-family: "Roboto", sans-serif;
            font-weight: 500;
            color: #262626;
            margin-left: 12px;
            padding: 0;
            cursor: pointer;
          }

          .cancel-delete {
            width: 24px;
            height: 24px;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-left: 24px;
            padding: 0;
            cursor: pointer;

            i {
              font-size: 14px;
              color: #c7c7c7;
              @include base-transition(ease color 0.15s);
            }

            &:hover {
              i {
                color: $atto-not-active;
              }
            }
          }
        }
      }
    }
  }
  .modal-head {
    padding: 46px 48px 0;
    display: flex;

    .modal-title {
      font-size: 1.25rem;
      line-height: 1.75rem;
      font-family: "Roboto", sans-serif;
      font-weight: 700;
      color: #262626;
    }
  }

  .time-interval {
    margin-left: auto;
    display: flex;
    flex-direction: row;
    width: 184px;
    align-items: center;
    .start-time,
    .end-time {
      min-width: 80px;
      max-width: 80px;
      padding: 8px;
      background-color: #f7f7f7;
      text-align: center;
      display: inline-block;

      /* Font Styles */
      font-size: 0.875rem;
      line-height: 1.5rem;
      font-family: "Roboto", sans-serif;
      font-weight: 500;
      color: #262626;
    }
    i {
      font-size: 9px;
      width: 24px;
      height: 24px;
      color: #c7c7c7;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}

button.delete-entry {
  margin: 0;
  padding: 0;
  margin-left: 24px;
  i {
    font-size: 24px;
    color: #efefef;
    @include base-transition(ease all 0.15s);
  }
  &:hover {
    i {
      color: #262626 !important;
    }
  }
}

.field-details {
  width: 100%;
  margin-bottom: 12px;
  .custom-control {
    align-items: center;
    padding-left: 32px;
    &:hover {
      cursor: pointer;
    }
  }

  .entry {
    display: inline-flex;
    align-items: center;

    i {
      font-size: 6px;
      margin-right: 6px;
    }
  }

  .entry-label {
    display: inline-flex;
    font-size: 0.875rem;
    line-height: 1.5rem;
    font-family: "Roboto", sans-serif;
    font-weight: 500;
    color: #262626;
    margin-bottom: 0;

    &:before {
      /*content: none;*/
    }

    &:after {
      /*content: none;*/
    }
  }
  .custom-radio {
    .custom-control-input:checked {
      ~ .custom-control-label {
        &::before {
          border-color: #00b9cb;
          background-color: transparent;
        }

        &::after {
          width: 12px;
          height: 12px;
          border-radius: 12px;
          left: -26px;
          top: 6px;
          background-color: #00b9cb;
          background-image: none;
        }
      }
    }
    .custom-control-input:focus ~ .custom-control-label::before {
      box-shadow: none;
    }
  }
}

.field-row {
  display: flex;
  flex-direction: row;
  .field-details {
    display: flex;
    flex-direction: row;
  }
  &:last-child {
    .field-details {
      margin-bottom: 0;
    }
  }
}

.modal-footer {
  &.overlap {
    display: flex;
    flex-direction: column !important;
    justify-content: flex-end;
    padding: 0 30px 24px;

    &:before {
      content: "";
      display: inline-flex;
      width: 100%;
      height: 2px;
      background-color: #efefef;
    }

    .atto-btn.cancel {
      margin-left: auto;
      margin-top: 8px;
      font-size: 1.125rem;
      line-height: 1.5rem;
      font-family: "Roboto", sans-serif;
      font-weight: 500;
      color: #999;
      text-align: right;
      width: 100px;
      justify-content: flex-end;
      text-transform: none;
      opacity: 1;
      margin-right: 0;
      background-color: transparent;
      height: 24px;
      padding: 0;
      &:hover {
        color: $atto-red;
      }
    }
  }
}
</style>
